import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { timePickerCustomTheme } from 'src/app/_helpers/timePickerTheme';
import { UserService } from 'src/app/_services';
import { ConfigService } from 'src/app/_services/config.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { SpaceDateFilterService } from '../space-date-filter/space-date-filter.service';

@Component({
  selector: 'app-parking-time-reservation',
  templateUrl: './parking-time-reservation.component.html',
  styleUrls: ['./parking-time-reservation.component.scss'],
})
export class ParkingTimeReservationComponent implements OnInit {

  @Input()
  timeToReservation: boolean = false

  @Input()
  forHowLongReservation: boolean = false

  @Input()
  startDate: Date = new Date();

  notificationConfirmation:boolean = false;

  // minTime = "8:00"; // Do sprawdzenia w Time Picker
  // maxTime = "19:00"; // Do sprawdzenia w Time Picker

  endDate: Date;
  maxDate: Date;
  validationError: boolean = false;
  timePickerCustomTheme = timePickerCustomTheme;
  errorMessage: string = "";
  data: {
    dateFrom: Date;
  };

  @ViewChild("buttonsContainer") buttonsContainer;

  spaceParkingBookingConfig = [];
  startTime = [];
  endTime = [];
  timePicker: boolean = false;
  endOfDay: boolean = false;
  infoMessage: boolean = false;

  constructor(
    public modalCtrl: ModalController,
    public userService: UserService,
    public p: ThisPlatform,
    public renderer: Renderer2,
    public spaceDateFilterService: SpaceDateFilterService,
    private router: Router,
    public configServ: ConfigService,
    public translate: TranslateService,
  ) {}

  ngOnInit() {
    this.spaceParkingBookingConfig = this.configServ.configs.filter((s) => 
      s.key.includes("space_parking_booking_config")
    );
    
    this.spaceParkingBookingConfig.forEach(e =>{
      this.startTime = e.value.startTime;
      this.endTime = e.value.endTime;
    })

    this.endTime.filter((s) => {
      if(s.type == 'endOfDay') {
        this.endOfDay = true;
      }
      if(s.type == 'datetimePickerE'){ 
        this.timePicker = true;
      }
    });

    if(this.timeToReservation) {
      this.startDate = new Date(this.startDate.getTime() + 5 * 60000) 
    }

    this.endTime = this.endTime.filter((el) => el.type == 'minute');
    this.endDate = new Date(this.startDate.getTime() + 30 * 60000)    
    this.maxDate = new Date(this.startDate.getTime() + 60 * 60 * 24 * 1000)
  }

  ngAfterViewInit() {
    if (!this.notificationConfirmation) {
      this.renderer.addClass(
        this.buttonsContainer.el.children[0].children[0],
        "parking-time-reservation-pick__hour-button--active"
      );
    }
  }

  onClose(){
    this.modalCtrl.dismiss(null);
  }

  onCloseModal(date: Date){
    if(date == null || date == undefined) {
      this.modalCtrl.dismiss();
    } else {
      this.modalCtrl.dismiss(date);
    }
  }

  onCloseModalBack(){
    this.modalCtrl.dismiss();
    this.router.navigate(["/app/parking"]);
  }

  onSetTime(event, value) {
    for (let item of this.buttonsContainer.el.children) {
      this.renderer.removeClass(
        item.children[0],
        "parking-time-reservation-pick__hour-button--active"
      );
    }
    this.renderer.addClass(
      event.currentTarget,
      "parking-time-reservation-pick__hour-button--active"
    );

    if (value == "byDayEnd") {
      this.setTime(value, true);
    } else {
      this.setTime(value, false);
    }
  }

  setTime(value, byDayEnd?: boolean) {
    let today = new Date();

    if(this.timeToReservation){
      this.startDate = new Date(new Date().getTime() + value * 60000);
      // this.onMinLimitTime();
    }

    if(this.forHowLongReservation){
      if(byDayEnd){
        this.endDate = new Date(today.setHours(19, 0));
      } else {
        this.endDate = new Date(this.startDate.getTime() + value * 60000)
      }
    }
  }

  setTimeTo(){
    this.spaceDateFilterService.setTimeToReservation = true;
    this.onCloseModal(this.startDate);
  }

  setTimeFor(){
    this.spaceDateFilterService.setTimeForHowLongReservation = true;
    this.onCloseModal(this.endDate);
  }

  dateTimeChange(event){
    this.endDate = event;
  }

}
